import { useCallback } from 'react';

import { useBridgeApi } from '@/api/BridgeApi';

// The back button every Space header shares. Chat is the one place back always
// means, since a Space is opened from Chat and has nowhere else to return to.
export const useBackToChat = (): (() => void) => {
	const bridgeApi = useBridgeApi();
	return useCallback(() => {
		bridgeApi.sendAction({ type: 'do_navigate_to_space', space_type: 'chat' });
	}, [bridgeApi]);
};
